import { getItemFromSessionStorage, setItemInSessionStorage } from "../hooks/sessionStorage";

const SESSION_ID_KEY = "session_id";
// Process-stable cache so the id survives mid-session sessionStorage clears
// (manual DevTools wipe, the brief window inside clearAllLocalSessionStorageThenRefresh
// before reload completes, etc.). Without this, PusherClient's captured id would
// drift apart from later postIntentEvent reads.
let cachedSessionId: string | null = null;

export function getSessionId(): string {
  if (cachedSessionId) {
    if (!getItemFromSessionStorage(SESSION_ID_KEY)) {
      setItemInSessionStorage(SESSION_ID_KEY, cachedSessionId);
    }
    return cachedSessionId;
  }
  let id = getItemFromSessionStorage(SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID?.() || Math.random().toString(36).substring(2);
    setItemInSessionStorage(SESSION_ID_KEY, id);
  }
  cachedSessionId = id;
  return id;
}
